const basePath = '/';
const baseRouterPath = '/dashboard';
const mmrmPath = `${baseRouterPath}/clep`;

const baseProjectPathConfig = {
  mmrm: mmrmPath,
};

export { basePath, baseRouterPath, mmrmPath, baseProjectPathConfig };
